<template>
  <div :class="{ calendar: true, active: active }" @click="$emit('slectedDate', date)">
    <div class="calendar-month">
      {{ $moment(date).format("MMM").split(" ")[0] }}
    </div>
    <div class="calendar-day">
      {{ $moment(date).format("DD") }}
    </div>
    <div class="calendar-time">
      {{ $moment(date).format('hh:mm A') }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    date: {
      type: Date,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>
